export default __webpack_public_path__ + "4960e80227d5effb0b973c6eac348392.svg";